// Sound cues — Web Audio API-driven, no MP3 assets. Opt-in via local-storage.
// See /app/memory/DESIGN_LANGUAGE_v2.md §7.

const OPT_IN_KEY = "astat.soundCues.enabled";

let ctx = null;
function audioContext() {
  if (typeof window === "undefined") return null;
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  return ctx;
}

export function isSoundEnabled() {
  if (typeof window === "undefined") return false;
  return localStorage.getItem(OPT_IN_KEY) === "true";
}

export function setSoundEnabled(on) {
  if (typeof window === "undefined") return;
  localStorage.setItem(OPT_IN_KEY, on ? "true" : "false");
}

function tone({ freq, dur = 0.2, gain = 0.08, type = "sine", delay = 0 }) {
  const c = audioContext();
  if (!c) return;
  const t0 = c.currentTime + delay;
  const osc = c.createOscillator();
  const g = c.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  g.gain.setValueAtTime(gain, t0);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  osc.connect(g);
  g.connect(c.destination);
  osc.start(t0);
  osc.stop(t0 + dur);
}

function haptic(pattern) {
  if (typeof navigator === "undefined" || !navigator.vibrate) return;
  navigator.vibrate(pattern);
}

export const cue = {
  tap() {
    if (!isSoundEnabled()) { haptic(10); return; }
    tone({ freq: 1200, dur: 0.06, gain: 0.05, type: "square" });
    haptic(10);
  },
  confirm() {
    if (isSoundEnabled()) {
      tone({ freq: 659.25, dur: 0.14 });   // E5
      tone({ freq: 880.0, dur: 0.16, delay: 0.09 }); // A5
    }
    haptic([12, 40, 22]);
  },
  badge_unlock() {
    if (isSoundEnabled()) {
      tone({ freq: 880, dur: 0.2 });
      tone({ freq: 1046.5, dur: 0.2, delay: 0.12 });
      tone({ freq: 1318.5, dur: 0.28, delay: 0.24 });
    }
    haptic([20, 30, 20, 30, 40]);
  },
  tier_up() {
    if (isSoundEnabled()) {
      tone({ freq: 880, dur: 0.24 });
      tone({ freq: 1046.5, dur: 0.24, delay: 0.14 });
      tone({ freq: 1318.5, dur: 0.4, delay: 0.28 });
      tone({ freq: 220, dur: 0.86, gain: 0.06, type: "sine", delay: 0.28 });
    }
    haptic([30, 40, 30, 40, 60]);
  },
  streak_extend() {
    if (isSoundEnabled()) tone({ freq: 1046.5, dur: 0.2, gain: 0.06 });
    haptic(15);
  },
  streak_lost() {
    if (isSoundEnabled()) {
      tone({ freq: 587.33, dur: 0.15 }); // D5
      tone({ freq: 392, dur: 0.18, delay: 0.1 }); // G4
    }
    haptic([25, 40, 25]);
  },
  va_alert() {
    if (isSoundEnabled()) {
      tone({ freq: 880, dur: 0.12, gain: 0.09 });
      tone({ freq: 1046.5, dur: 0.12, gain: 0.09, delay: 0.14 });
      tone({ freq: 880, dur: 0.12, gain: 0.09, delay: 0.28 });
    }
    haptic([40, 40, 40, 40, 40]);
  },
  pod_signed() {
    if (isSoundEnabled()) {
      tone({ freq: 1500, dur: 0.04, type: "square", gain: 0.08 });
      tone({ freq: 220, dur: 0.4, delay: 0.05 });
      tone({ freq: 330, dur: 0.4, delay: 0.05 });
    }
    haptic([20, 60]);
  },
  hash_lock() {
    if (isSoundEnabled()) tone({ freq: 110, dur: 0.24, gain: 0.09 });
    haptic([15, 45]);
  },
};
